/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 15/2/2023
 */

import BaseObject from "@shared/BaseObject.js";
import CommonObject from "@shared/CommonObject";

export default class BaseIdObject extends BaseObject {

	id: string = null

	constructor(options) {
		super(options);
		this.generateId()
	}

	setId(id){
		this.id = id
		return this
	}

	generateId(){
		this.regenerateId()
		return this
	}

	resetObject(){
		super.resetObject()
		this.regenerateId()
	}

	prepareForCopy(){
		super.prepareForCopy()
		this.resetObject()
	}

	regenerateId(){
		if(CommonObject.dataManager){
			this.id = CommonObject.dataManager.generateId()
		} else {
			this.id = null
		}
		return this
	}

}
